import React from 'react'
import MediaWithShimmer from './MediaWithShimmer'
import GoldenZigzag from './GoldenZigzag'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from '../translations/translations'
import worldVideo7 from '../img/Видео WhatsApp 2025-11-17 в 12.06.10_05ef68d7.mp4'

const Philosophy = () => {
  const { language } = useLanguage()
  const t = translations.philosophy

  const handleAnchorClick = (e, href) => {
    if (href.startsWith('#')) {
      e.preventDefault()
      const id = href.substring(1) // Remove '#'
      const element = document.getElementById(id)
      if (element) {
        const headerOffset = 80
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  }

  return (
    <section id="world" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center">
          <div className="inline-block max-w-full">
            <h3 className="text-4xl md:text-5xl lg:text-[3rem] font-black text-black tracking-[0.08em] uppercase mb-3 leading-tight break-words">
              {t.title[language]}
            </h3>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Philosophy

